<ng-container *ngIf="loader">
    <div class="row my-4">
        <div class="d-flex justify-content-center">
            <div class="dot-pulse mY-25-50"></div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!loader">
    <ng-container *ngIf="legDetails.length == 0">
        <div class="row my-4">
            <div class="d-flex justify-content-center">
                <span class="text-danger">
                    <b>No record found!</b>
                </span>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="legDetails.length > 0">
        <div class="row">
            <div
                *ngFor="let details of legDetails; let i = index"
                [ngClass]="{
                    'col-lg-6': !legDetailsConfig.isShownInFullWidth && legDetails.length > 1,
                    'col-lg-12': legDetailsConfig.isShownInFullWidth,
                }"
            >
                <div class="card card-border trip-details-card">
                    <!---Need to use ngFor directive to show multiple records -->
                    <div class="row py-2">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mx-4 mt-2">
                            <ng-container
                                *ngIf="
                                    legDetailsConfig &&
                                    legDetailsConfig.requestFor == requestFor.LegAssignmentRequests &&
                                    !isAdminRole &&
                                    !isInternalReadOnly &&
                                    !isManagementRole
                                "
                            >
                                <input
                                    id="assignmentReqCheckBox"
                                    class="mr-2"
                                    #checkboxRef
                                    type="checkbox"
                                    [disabled]="legDetailService.isCheckBoxDisable(details.assignmentRequestStatus, details.transportType)"
                                    (change)="toggleSelection(details, checkboxRef)"
                                />
                            </ng-container>
                            <h4 id="tripIdH4" class="d-inline-block">
                                <b>{{ details.tripId }}</b>
                            </h4>
                            <ng-container
                                *ngIf="
                                    legDetailsConfig &&
                                    legDetailsConfig.requestFor == requestFor.LegAssignmentRequests &&
                                    !isAdminRole &&
                                    !isInternalReadOnly &&
                                    !isManagementRole
                                "
                            >
                                <button
                                    *ngIf="details.assignmentRequestStatus != 'Accepted'"
                                    class="float-right btn btn-success actionBtnPositionAdjustments"
                                    title="Accept the assignment request"
                                    (click)="legDetailService.acceptOrRejectLegAssignmentRequest(details, legDetailsConfig, true)"
                                >
                                    Accept
                                </button>
                                <button
                                    *ngIf="details.assignmentRequestStatus == 'Accepted' && !details.isAssigned"
                                    class="float-right btn btn-success actionBtnPositionAdjustments"
                                    title="Assign Driver"
                                    (click)="legDetailService.openAssignOrRejectDialog([details], 'Assign Driver')"
                                >
                                    Assign
                                </button>
                                <button
                                    *ngIf="details.assignmentRequestStatus != 'Accepted'"
                                    class="float-right btn ml-0 mr-3"
                                    title="Reject the assignment request"
                                    (click)="legDetailService.acceptOrRejectLegAssignmentRequest(details, legDetailsConfig, false)"
                                >
                                    <i class="fa fa-lg fa-trash text-danger"></i>
                                </button>
                            </ng-container>
                            <ng-container *ngIf="!legDetailsConfig.isGetLegStatusList">
                                <div class="float-right-min-425 mt-3 font-xs">
                                    <span
                                        *ngIf="forPage == 'common-itinerary' && user.role != 'OutSideOrg'"
                                        class="text-danger cursorPointer mr-3"
                                        data-target="#FeedbackFile"
                                        data-toggle="modal"
                                        (click)="openAddNotePopup(details.legId, false)"
                                    >
                                        <strong>Show Notes</strong>
                                    </span>
                                    <span
                                        *ngIf="forPage == 'common-itinerary'"
                                        class="text-danger cursorPointer mr-3"
                                        (click)="emitLegDetail(details)"
                                    >
                                        <strong>Show Map</strong>
                                    </span>
                                    <span
                                        *ngIf="legDetailsConfig.isBadgeVisible == true"
                                        class="custom-select custom-select-sm grid-header-element actionBtnPositionAdjustments status-filter p-2 cursorArrow"
                                        [ngClass]="legDetailService.returnStatusClassConfig(details.status)"
                                    >
                                        {{ details.status }}
                                    </span>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="legDetailsConfig.isGetLegStatusList">
                                <div class="btn-group my-2 float-right actionBtnPositionAdjustments">
                                    <select
                                        class="margin-left-7 custom-select custom-select-sm grid-header-element status-filter"
                                        aria-controls="example1"
                                        [disabled]="isInternalReadOnly"
                                        [ngClass]="legDetailService.returnStatusClassConfig(details.status)"
                                        [(ngModel)]="details.status"
                                        (change)="updateLegStatus(details.legId, details.status)"
                                    >
                                        <option
                                            *ngFor="
                                                let status of details.transportType == transportType.GROUND
                                                    ? vehicleStatusList
                                                    : airCraftStatusList
                                            "
                                            style="background: white; color: black"
                                            [disabled]="
                                                legDetailService.returnStatusDisabledConfig(
                                                    details.transportType,
                                                    details.status,
                                                    status.name
                                                )
                                            "
                                            [value]="status.name"
                                        >
                                            {{ status.name }}
                                        </option>
                                    </select>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <span>UNOS: {{ details?.unosId }}</span>
                        <i class="fa fa-sm fa-circle ml-2" style="font-size: 0.7em"></i>
                        <span
                            id="serviceSubType{{ i }}"
                            class="picked-up-color ml-2 cursorPointer"
                            data-placement="auto bottom"
                            data-toggle="popover"
                            [attr.data-content]="details.serviceSubType.split(',').join(', ')"
                            [title]="details.serviceType"
                            (click)="togglePopOver()"
                        >
                            {{ details.serviceType }}
                        </span>
                        <i *ngIf="legDetailsConfig.isShowServiceRequestLink" class="fa fa-sm fa-circle ml-2" style="font-size: 0.7em"> </i>
                        <a
                            *ngIf="legDetailsConfig.isShowServiceRequestLink"
                            class="picked-up-color cursorPointer ml-2"
                            (click)="navigateToItinerarypage(details.serviceRequestId)"
                            ><u>{{ this.detailLinkName }}</u>
                        </a>
                        <span
                            class="badge ml-2 cursorArrow"
                            [ngClass]="legDetailService.returnTransportTypeClassConfig(details.transportType)"
                        >
                            {{ details.transportType }}
                        </span>
                        <span
                            *ngIf="!isCustomer && details.deliveryNote != null && details.deliveryNote != ''"
                            id="deliveryNote{{ i }}"
                            class="badge ml-2 deliveryNote cursorPointer"
                            data-placement="auto bottom"
                            data-toggle="popover"
                            title="Delivery Note"
                            [attr.data-content]="details.deliveryNote"
                            (click)="togglePopOver()"
                        >
                            Delivery Note
                        </span>
                    </div>
                    <div class="row px-4 py-2">
                        <div
                            class="col-lg-6 col-md-6 col-sm-6 line-right"
                            [ngClass]="{
                                'col-sm-6': !legDetailsConfig.isShowTransportDetails,
                                'col-sm-12': legDetailsConfig.isShowTransportDetails,
                            }"
                        >
                            <div class="mb-3">
                                <span class="circle-icon-container"><i class="fa fa-solid fa-circle" style="color: #a82b41"></i></span>
                                <span class="px-3">- - - - - - - - - - - - - - - -</span>
                                <span style="font-size: 1.2em; color: #828282"><i class="fa fa-lg fa-solid fa-map-marker"></i></span>
                            </div>
                            <div class="locationDetailContainer scrollbarView">
                                <span class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                                    <div>{{ details.origin }}</div>
                                    <div>{{ details.originAddress }}</div>
                                    <div>{{ details.originAddressLocation }}</div>
                                </span>
                                <span class="col-lg-6 col-md-6 col-sm-6 col-xs-6 destinationDetails">
                                    <div>{{ details.destination }}</div>
                                    <div>{{ details.destinationAddress }}</div>
                                    <div>{{ details.destinationAddressLocation }}</div>
                                </span>
                            </div>
                        </div>
                        <div
                            class="col-sm-6"
                            [ngClass]="{
                                'col-lg-6 col-md-6 col-xs-12': !legDetailsConfig.isShowTransportDetails,
                                'col-lg-3 col-md-3 col-xs-6': legDetailsConfig.isShowTransportDetails,
                            }"
                        >
                            <span
                                class="px-0"
                                [ngClass]="{
                                    'col-lg-6 col-md-6 col-sm-12 col-xs-6': !legDetailsConfig.isShowTransportDetails,
                                    'col-lg-12 col-md-12 col-sm-12 col-xs-12': legDetailsConfig.isShowTransportDetails,
                                }"
                            >
                                <div class="mt-1"><b>Pickup</b></div>
                                <div class="mt-3">{{ details.plannedPickUpDateTime | localDate: timeZone }}</div>
                            </span>
                            <span
                                class="px-0"
                                [ngClass]="{
                                    'col-lg-6 col-md-6 col-sm-12 col-xs-6': !legDetailsConfig.isShowTransportDetails,
                                    'col-lg-12 col-md-12 col-sm-12 col-xs-12': legDetailsConfig.isShowTransportDetails,
                                }"
                            >
                                <div class="mt-1"><b>Dropoff</b></div>
                                <div class="mt-3">{{ details.plannedDropOffDateTime | localDate: timeZone }}</div>
                            </span>
                            <span
                                *ngIf="!legDetailsConfig.isShowTransportDetails"
                                class="px-0 mt-2 col-lg-12 col-md-12 col-sm-12 col-xs-12"
                            >
                                <div class="mt-1"><b>Transport Category</b></div>
                                <div class="mt-3">{{ details.transportCategory ? details.transportCategory : 'NA' }}</div>
                            </span>
                        </div>
                        <div *ngIf="legDetailsConfig.isShowTransportDetails" class="col-lg-3 col-md-3 col-sm-6 line-left">
                            <span>
                                <div class="mt-1"><b>Transport</b></div>
                                <div class="mt-3">{{ details.vehicelName }}</div>
                                <div style="color: #a82b41 !important">
                                    <ng-container *ngIf="details.transportType == 'Air'">
                                        <a
                                            class="cursorPointer"
                                            href="https://flightaware.com/live/flight/{{ details.vehicleNumber }}"
                                            target="blank"
                                        >
                                            {{ details.vehicleNumber }}
                                        </a>
                                    </ng-container>
                                    <ng-container *ngIf="details.transportType == 'Ground'">
                                        <span class="cursorArrow">
                                            {{ details.vehicleNumber }}
                                        </span>
                                    </ng-container>
                                </div>
                                <div class="picked-up-color">{{ details.driverName }}</div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>

<app-note-file-modal
    *ngIf="requestIDForNotes && isNotesModelOpen"
    [businessUnitId]="requestIDForNotes"
    [fromPage]="'common-itinerary'"
    [header]="'Notes'"
    [isBadgeVisible]="isBadgeVisible"
    (isCloseModel)="closeNotesModel()"
>
</app-note-file-modal>
